import queryString from 'query-string';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import SecureRoutesContainer from '../containers/SecureRoutesContainer';
import { makePostRequest as biztechPostRequest } from '../helpers/biztechAxiosRequest';
import './CreateCustomer.css';

class CreateCustomer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      companyPrefix: 'AVATEST - '
    };
  }

  handleInputChange = e => {
    const value = e.target.value;
    this.setState({ [e.target.name]: value });
  };

  copyAddressToContact = e => {
    e.preventDefault();

    this.setState({
      contactStAddr: this.state.companyStAddr,
      contactStAddr2: this.state.companyStAddr2,
      contactCity: this.state.companyCity,
      contactState: this.state.companyState,
      contactCountry: this.state.companyCountry,
      contactZip: this.state.companyZip
    });
  };

  createCustomer = event => {
    event.preventDefault();

    this.setState({ loading: true });

    const endpoint = '/customer/customer-accounts';

    const companyStreet = this.state.companyStAddr
      ? this.state.companyStAddr2
        ? this.state.companyStAddr + ', ' + this.state.companyStAddr2
        : this.state.companyStAddr
      : this.state.companyStAddr2
      ? this.state.companyStAddr2
      : '';

    const requestBody = {
      name: this.state.companyPrefix + this.state.companyName,
      ...(companyStreet && { street: companyStreet }),
      ...(this.state.companyCity && { city: this.state.companyCity }),
      ...(this.state.companyState && { state: this.state.companyState }),
      ...(this.state.companyCountry && { country: this.state.companyCountry }),
      ...(this.state.companyZip && { postalCode: this.state.companyZip }),
      contacts: [
        {
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          email: this.state.email,
          street: this.state.contactStAddr
            ? this.state.contactStAddr2
              ? this.state.contactStAddr + ', ' + this.state.contactStAddr2
              : this.state.contactStAddr
            : this.state.contactStAddr2
            ? this.state.contactStAddr2
            : '',
          city: this.state.contactCity,
          state: this.state.contactState,
          country: this.state.contactCountry,
          postalCode: this.state.contactZip
        }
      ]
    };

    // const headers = { Authorization: `Bearer ${this.props.auth.token}` };

    biztechPostRequest(endpoint, requestBody)
      .then(res => {
        if (res.status === 201) {
          if (res.data && res.data.data && res.data.data.id) {
            let trimmedId = res.data.data.id.trim();

            if (trimmedId) {
              return this.dispatchSearch(trimmedId);
            }
          } else {
            this.setError('Successfully created a customer');
          }
        } else if (res.status === 202) {
          if (res.data && res.data.data && res.data.data.id) {
            let trimmedId = res.data.data.id.trim();

            if (trimmedId) {
              this.setError(`Account already exists. Account Id: ${trimmedId}`);
            }
          } else {
            this.setError('Account already exists');
          }
        } else {
          this.setError('Sorry, something went wrong!');
        }
      })
      .catch(err => {
        if (err.response) {
          const res = err.response;

          if (res.status === 400) {
            if (
              res.data &&
              res.data.errors &&
              res.data.errors[0] &&
              res.data.errors[0].message
            ) {
              this.setError(res.data.errors[0].message);
            } else {
              this.setError('Bad request. Please check your inputs.');
            }
          } else if (res.status === 500 || res.status === 502) {
            this.setError('Sorry, something went wrong!');
          }
          this.setError('Sorry, something went wrong!');
        } else if (err.request) {
          // Request is formed but no response from server
          this.setError('Sorry, something went wrong!');
        } else {
          // Error in forming the request
          this.setError('Sorry, something went wrong!');
        }
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  setError = err => {
    this.setState({ errorMsg: err });
  };

  dispatchSearch = id => {
    const stringifiedQuery = queryString.stringify({ query: id });
    this.props.dispatch(push(`/search?${stringifiedQuery}`));
  };

  render() {
    // if (!(this.props.auth.roles.includes("DG-OPUS-ProvisioningAccess") ||
    //       this.props.auth.roles.includes("DG-ProductManagement"))) {
    //     return (<div><h1>Access Denied </h1><h3>you must be part of DG-OPUS-ProvisioningAccess or DG-ProductManagement</h3> </div>)
    // }

    // if (this.state.loading) {
    //     return (<div> <br /><br /> <br />   <img src={loadingGif} alt="Please wait" /> <h1>processing ...</h1>  </div>)
    // }

    return (
      <SecureRoutesContainer page="create-customer">
        <s-container>
          <h1>Create New Customer</h1>
          <form aria-label="create new customer" onSubmit={this.createCustomer}>
            <fieldset className="padding-10">
              <div className="ml-20 mr-20">
                <s-row>
                  <s-col span="5">
                    <h3 className="text-left">Company</h3>
                    <s-row>
                      <s-col span="4">
                        <select
                          name="companyPrefix"
                          value={this.state.companyPrefix}
                          onChange={this.handleInputChange}
                        >
                          <option value="AVATEST - ">AVATEST</option>
                          <option value="NFR - ">NFR</option>
                        </select>
                      </s-col>
                      <s-col span="8">
                        <input
                          type="text"
                          id="create-customer-company-name"
                          name="companyName"
                          placeholder="Comapny Name"
                          onChange={this.handleInputChange}
                          value={this.state.companyName}
                          required
                        />
                      </s-col>
                    </s-row>
                    {this.state.companyName && this.state.companyName !== '' ? (
                      <div
                        id="actual-company-name"
                        name="actualCompanyName"
                        className="text-left mt-0375rem ava-color"
                      >
                        Actual Company Name:
                        <br />
                        <span
                          id="span-actual-company-name"
                          className="mt-0375rem"
                        >
                          {this.state.companyPrefix + this.state.companyName}
                        </span>
                      </div>
                    ) : (
                      ''
                    )}
                  </s-col>
                  <s-col span="2"></s-col>
                  <s-col span="5">
                    <h3 className="text-left">Contact</h3>

                    <input
                      type="text"
                      id="create-customer-first-name"
                      name="firstName"
                      placeholder="First Name"
                      onChange={this.handleInputChange}
                      value={this.state.firstName}
                      required
                    />

                    <input
                      type="text"
                      id="create-customer-last-name"
                      name="lastName"
                      placeholder="Last Name"
                      onChange={this.handleInputChange}
                      value={this.state.lastName}
                      required
                    />

                    <input
                      type="email"
                      id="create-customer-email"
                      name="email"
                      placeholder="Email"
                      onChange={this.handleInputChange}
                      value={this.state.email}
                      required
                    />
                  </s-col>
                </s-row>
                <s-row class="mt-30">
                  <s-col span="5" className="divider-right">
                    <input
                      type="text"
                      id="create-customer-company-st-addr"
                      name="companyStAddr"
                      placeholder="Company Street Addr"
                      onChange={this.handleInputChange}
                      value={this.state.companyStAddr}
                    />

                    <input
                      type="text"
                      id="create-customer-company-st-addr2"
                      name="companyStAddr2"
                      placeholder="Company Street Addr2"
                      onChange={this.handleInputChange}
                      value={this.state.companyStAddr2}
                    />

                    <input
                      type="text"
                      id="create-customer-company-city"
                      name="companyCity"
                      placeholder="Company City"
                      onChange={this.handleInputChange}
                      value={this.state.companyCity}
                    />

                    <input
                      type="text"
                      id="create-customer-company-state"
                      name="companyState"
                      placeholder="Company State"
                      onChange={this.handleInputChange}
                      value={this.state.companyState}
                    />

                    <input
                      type="text"
                      id="create-customer-company-country"
                      name="companyCountry"
                      placeholder="Company Country"
                      onChange={this.handleInputChange}
                      value={this.state.companyCountry}
                    />

                    <input
                      type="text"
                      id="create-customer-company-zip"
                      name="companyZip"
                      placeholder="Company Zip"
                      onChange={this.handleInputChange}
                      value={this.state.companyZip}
                    />
                  </s-col>
                  <s-col span="2" className="divider-right">
                    <div className="self-center">
                      <button
                        className="primary ht-auto"
                        id="btn-cpy-addr-to-contact"
                        onClick={this.copyAddressToContact}
                      >
                        Copy Address
                      </button>
                    </div>
                  </s-col>
                  <s-col span="5">
                    <input
                      type="text"
                      id="create-customer-contact-st-addr"
                      name="contactStAddr"
                      placeholder="Street Addr"
                      onChange={this.handleInputChange}
                      value={this.state.contactStAddr}
                      required
                    />

                    <input
                      type="text"
                      id="create-customer-contact-st-addr2"
                      name="contactStAddr2"
                      placeholder="Street Addr2"
                      onChange={this.handleInputChange}
                      value={this.state.contactStAddr2}
                    />

                    <input
                      type="text"
                      id="create-customer-contact-city"
                      name="contactCity"
                      placeholder="City"
                      onChange={this.handleInputChange}
                      value={this.state.contactCity}
                    />

                    <input
                      type="text"
                      id="create-customer-contact-state"
                      name="contactState"
                      placeholder="State"
                      onChange={this.handleInputChange}
                      value={this.state.contactState}
                      required
                    />

                    <input
                      type="text"
                      id="create-customer-contact-country"
                      name="contactCountry"
                      placeholder="Country"
                      onChange={this.handleInputChange}
                      value={this.state.contactCountry}
                      required
                    />

                    <input
                      type="text"
                      id="create-customer-contact-zip"
                      name="contactZip"
                      placeholder="Zip"
                      onChange={this.handleInputChange}
                      value={this.state.contactZip}
                      required
                    />
                  </s-col>
                </s-row>
                <br />
                <s-row class="mt-20">
                  <s-col span="8">
                    {this.state.errorMsg ? (
                      <s-alert status="error" nodismiss="">
                        <div>{this.state.errorMsg}</div>
                      </s-alert>
                    ) : (
                      ''
                    )}
                  </s-col>
                  <s-col span="4">
                    <button
                      type="submit"
                      className="primary float-right"
                      disabled={this.state.loading}
                    >
                      Submit
                    </button>
                  </s-col>
                </s-row>
              </div>
            </fieldset>
          </form>
        </s-container>
      </SecureRoutesContainer>
    );
  }
}

export default connect(({ auth }) => ({ auth }))(CreateCustomer);
